module.exports = __webpack_public_path__ + "static/media/tires_icon.ffbe15ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cuiIcons/tires_icon.png
// module id = 1741
// module chunks = 0